module.exports = __webpack_public_path__ + "static/apple-icon-180x180-7cd41a8f653d300ea8c9cf09f87ca01b.png";